import { useState, useEffect } from 'react'
import { collection, doc, getDocs, query } from 'firebase/firestore'
import { db } from '../../assets/connections'

const usePlayersData = (ref) => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchData = async () => {
        if (!ref) return
        setLoading(true)
        setError(null)

        try {
            const [subsSnap, playersSnap, classesSnap, sedesSnap] = await Promise.all([
                getDocs(query(collection(doc(db, ref), "Suscripciones"))),
                getDocs(query(collection(doc(db, ref), "Jugador"))),
                getDocs(query(collection(doc(db, ref), "Clases"))),
                getDocs(collection(doc(db, ref), "Sedes")).catch(() => ({ docs: [] }))
            ])

            const subscriptions = subsSnap.docs.map(v => ({ id: v.id, ...v.data() }))

            const players = playersSnap.docs.map(v => {
                const d = v.data()
                return {
                    id: v.id,
                    correo_jugador: d.correo_jugador,
                    nombre_jugador: d.nombre_jugador,
                    suscripciones_jugador: d.suscripciones_jugador || [],
                    suscripciones_jugador_aux: JSON.parse(JSON.stringify(d.suscripciones_jugador || [])),
                    player_ref: v.ref.path,
                    nivel_jugador: d.nivel_jugador,
                    ranking_jugador: d.ranking_jugador,
                    categoria_jugador: d.categoria_jugador,
                    rama_jugador: d.rama_jugador,
                    asistencias: d.asistencias || [],
                    asistencias_jugador: d.asistencias_jugador,
                    ultima_asistencia: d.ultima_asistencia,
                    edad_jugador: d.edad_jugador,
                    fecha_alta: d.fecha_alta,
                    fecha_baja: d.fecha_baja,
                    telefono_jugador: d.telefono_jugador,
                    clases_jugador: d.clases_jugador,
                    sede_default: d.sede_default || "",
                    nombre_sede_default: d.nombre_sede_default || ""
                }
            }).sort((a, b) =>
                a.nombre_jugador.localeCompare(b.nombre_jugador, "es", { sensitivity: "base" })
            )

            const classes = classesSnap.docs.map(v => ({
                id: v.id,
                nombre_clase: v.data().nombre_clase,
                dias_clase: v.data().dias_clase
            }))

            const sedes = sedesSnap.docs.map(v => ({
                id: v.id,
                nombre_sede: v.data().nombre_sede,
                es_default: v.data().es_default || false
            }))

            setData({ subscriptions, players, classes, sedes })
            setLoading(false)
        } catch (e) {
            console.log(e)
            setError(e.message || "Error al cargar datos")
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [ref])

    return { data, loading, error, reload: fetchData }
}

export default usePlayersData
